import { withChildren } from '@builder.io/react';

import { createBuilderModule } from '../../../builder';
import { imgElement } from '../../../builder/element-factories';
import { CTASection } from './CTASection';
import { defaultValues } from '../../Block/Block.builder';
import { withTracking } from '../../../observability';
import {
  CtaGoal,
  CtaName,
  SectionName,
} from '../../../observability/tracking/events';
import { CTASectionVariant } from '../../../global/types';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withChildren(
    withTracking(CTASection, {
      as: 'section',
      sectionName: SectionName.CTASection,
    }),
  ),
  {
    name: 'CtaSection',
    image:
      'https://cdn.zapier.com/storage/photos/e5f1d03939df5f074b24b06198cfcbaa.png',
    inputs: [
      {
        name: 'variant',
        type: 'string',
        enum: [
          CTASectionVariant.standard,
          CTASectionVariant.filled,
          CTASectionVariant.centered,
        ],
        defaultValue: CTASectionVariant.standard,
      },
      {
        name: 'background',
        type: 'string',
        enum: [
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        defaultValue: COLOR_KEYS.neutral100,
      },
      {
        name: 'heading',
        type: 'string',
        defaultValue: defaultValues.heading,
        required: true,
      },
      {
        name: 'subHeading',
        type: 'string',
        defaultValue: 'Default sub heading (edit me)',
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'ctaText',
        type: 'string',
        defaultValue: defaultValues.ctaText,
      },
      {
        name: 'ctaHref',
        type: 'string',
        defaultValue: defaultValues.ctaHref,
      },
      {
        name: 'ctaName',
        type: 'string',
        enum: Object.values(CtaName),
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
        defaultValue: defaultValues.ctaName,
        required: true,
      },
      {
        name: 'ctaGoal',
        type: 'string',
        enum: Object.values(CtaGoal),
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
        defaultValue: defaultValues.ctaGoal,
        required: true,
      },
      {
        name: 'ctaBtnColor',
        friendlyName: 'CTA button color',
        type: 'string',
        enum: ['primary', 'primary-alt', 'primary-dark', 'brand'],
      },
      {
        name: 'maxWidth',
        type: 'number',
      },
      {
        name: 'openInNewTab',
        helperText: 'Controls whether or not the CTA link opens in a new tab',
        type: 'boolean',
      },
    ],
    defaultChildren: [
      imgElement({
        src: 'https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png',
      }),
    ],
    childRequirements: {
      message: 'You can only use Img Block',
      query: {
        'component.name': { $in: ['img'] },
      },
    },
  },
);
